<template>
    <div class="nav second-menu">
            <ul>
                <promoCode v-if="!isMobile"></promoCode>
                <li>
                    <router-link  :to="{ name: 'Promotions' }" type="button">
                        <div class="icon">
                            <img src="@/assets/images/common/icons/promotion.png" width="18">
                        </div>
                        <span>Promosyonlar</span>  
                    </router-link>
                </li>
                <li>
                    <a href="https://macvardi3.link/" target="_blank">
                        <div class="icon">
                            <img src="@/assets/images/common/icons/tv.png" width="18">
                        </div>
                        <span>Maç İzle</span>
                    </a>
                </li>
                <li>
                    <a href="https://forms.gle/qZn91RBqszuw7BFV7" target="_blank">
                        <div class="icon">
                            <img src="@/assets/images/common/icons/call.png" width="18">
                        </div>
                        <span>Aranma Talebi</span>
                    </a>
                </li>
                <li>
                    <router-link :to="{ name: 'Affiliate' }" type="button">
                        <div class="icon">
                            <img src="@/assets/images/common/icons/aff.png" width="18">
                        </div>
                        <span> Ortaklık Programı</span>
                    </router-link>
                </li>
            </ul>
        </div>
</template>
<script>
  import promoCode from './promoCode';
  export default{
    components:{
        promoCode,
    }
  }
</script>